import { jsx } from "react/jsx-runtime";
const FillArrowDown = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            d: "M10.65 14.962a2 2 0 0 0 3.11 0l3.968-4.91c1.057-1.307.126-3.257-1.555-3.257H8.237c-1.682 0-2.613 1.95-1.556 3.258l3.968 4.909Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const FillArrowDown_FillArrowDown = FillArrowDown;
export default FillArrowDown_FillArrowDown;
